var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.73 13.37L4.762 12.692L5.128 12.87C5.975 13.281 6.943 13.5 8 13.5C11.496 13.5 14 11.002 14 8C14 4.987 11.514 2.5 8 2.5C4.486 2.5 2 4.987 2 8C2.00591 9.15303 2.38556 10.273 3.082 11.192L3.42 11.642L2.73 13.369V13.37ZM2.023 14.66C1.93251 14.6903 1.83523 14.6941 1.74265 14.6709C1.65007 14.6477 1.56607 14.5985 1.50056 14.5291C1.43505 14.4597 1.39077 14.373 1.37295 14.2793C1.35513 14.1855 1.36452 14.0886 1.4 14L2.283 11.793C1.45618 10.7008 1.00598 9.36985 1 8C1 4.686 3.682 1.5 8 1.5C12.318 1.5 15 4.686 15 8C15 11.314 12.29 14.5 8 14.5C6.755 14.5 5.643 14.232 4.692 13.77L2.022 14.66H2.023Z",
    fill: "#FFFEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.8380bd16075b7e42f666495a036b05a3.svg";
export { ForwardRef as ReactComponent };